function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.55 12.9812L20.7 8.33125C20.8917 7.75 21.6583 5.0375 20.125 2.7125C18.975 0.96875 16.675 0 13.4167 0H9.58333C6.325 0 4.025 0.96875 2.875 2.7125C1.34167 5.0375 2.10833 7.55625 2.3 8.33125L3.45 12.9812C1.34167 15.1125 0 18.0187 0 21.3125C0 25.3813 2.10833 28.8687 5.175 31H17.825C20.8917 28.8687 23 25.3813 23 21.3125C23 18.0187 21.6583 15.1125 19.55 12.9812ZM6.9 10.6562L5.94167 7.3625V7.16875C5.94167 7.16875 5.55833 5.8125 6.13333 5.0375C6.51667 4.2625 7.66667 3.875 9.58333 3.875H13.4167C15.1417 3.875 16.4833 4.2625 17.0583 4.84375C17.6333 5.61875 17.25 6.975 17.25 6.975L16.2917 10.6562C14.7583 10.075 13.225 9.6875 11.5 9.6875C9.775 9.6875 8.24167 10.075 6.9 10.6562Z",
  fill: "#FFA826"
});

var SvgKettlebellInfo = function SvgKettlebellInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKettlebellInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kettlebell-info.2475ad2b.svg";
export { ForwardRef as ReactComponent };